var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xs-12" }, [
    _c(
      "div",
      {
        staticClass: "button-toolbar",
        attrs: { id: _vm.elId + "-language-selector" }
      },
      [
        _c(
          "div",
          { staticClass: "btn-group" },
          [
            _vm._l(_vm.getInChunks[0], function(languageTerm, language) {
              return _c(
                "button",
                {
                  key: language + "-button",
                  class:
                    "btn btn-" +
                    (language == _vm.currentLanguage
                      ? "primary active"
                      : "default"),
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.setCurrentLanguage(language)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(languageTerm) +
                      "\n            "
                  )
                ]
              )
            }),
            _vm.getInChunks.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default dropdown-toggle",
                    attrs: { "data-toggle": "dropdown" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("translate")("More Languages")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "caret" })
                  ]
                )
              : _vm._e(),
            _c(
              "ul",
              { staticClass: "dropdown-menu" },
              _vm._l(_vm.getInChunks[1], function(languageTerm, language) {
                return _c(
                  "li",
                  {
                    key: language + "-dropdown",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.setCurrentLanguage(language)
                      }
                    }
                  },
                  [
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v(_vm._s(languageTerm))
                    ])
                  ]
                )
              }),
              0
            )
          ],
          2
        )
      ]
    ),
    _c("hr")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }